/**
 * Service Webhooks de saída (ADR-0062).
 *
 * WebhookEndpoint (CRUD + secret copy-once) + log de entregas.
 * O secret aparece SOMENTE na resposta de criar/rotacionar — guarde na
 * hora; nenhuma outra chamada o devolve.
 */

const PREFIXO = "/api/webhook-endpoints";


export function listarEndpoints(request) {
  return request(PREFIXO);
}

export function criarEndpoint(request, dados) {
  return request(PREFIXO, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarEndpoint(request, id, dados) {
  return request(`${PREFIXO}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function excluirEndpoint(request, id) {
  return request(`${PREFIXO}/${id}`, { method: "DELETE" });
}

export function rotacionarSecret(request, id) {
  return request(`${PREFIXO}/${id}/rotacionar-secret`, { method: "POST" });
}

export function testarEndpoint(request, id) {
  return request(`${PREFIXO}/${id}/testar`, { method: "POST" });
}

export function listarEntregas(request, id, params = {}) {
  const query = new URLSearchParams();
  if (params.situacao) query.set("situacao", params.situacao);
  if (params.limite) query.set("limite", params.limite);
  const sufixo = query.toString() ? `?${query}` : "";
  return request(`${PREFIXO}/${id}/entregas${sufixo}`);
}

export function reenviarEntrega(request, endpointId, entregaId) {
  return request(`${PREFIXO}/${endpointId}/entregas/${entregaId}/reenviar`, {
    method: "POST",
  });
}

export function obterResumo(request) {
  return request(`${PREFIXO}/resumo`);
}

export function listarEventosDisponiveis(request) {
  return request(`${PREFIXO}/eventos-disponiveis`);
}

export const SITUACOES_ENTREGA = {
  PENDENTE: { label: "Pendente", tone: "info" },
  ENTREGUE: { label: "Entregue", tone: "success" },
  FALHOU: { label: "Aguardando retry", tone: "warning" },
  ESGOTADA: { label: "Esgotada", tone: "danger" },
};
